import { Line1Input } from '@Components/inputs/Line1';
import { Line1AutocompleteInput } from './Line1AutocompleteInput';

interface Props {
  isUsResident: boolean;
  disabled: boolean;
  tabIndex: number;
  validStates?: { title: string; value: string }[];
}

export const Line1AddressInput = ({ isUsResident, disabled, tabIndex, validStates }: Props) =>
  isUsResident ? (
    <Line1AutocompleteInput disabled={disabled} tabIndex={tabIndex} validStates={validStates} />
  ) : (
    <Line1Input disabled={disabled} tabIndex={tabIndex} />
  );
